import React, { useState, useEffect } from "react";
import { modal, showSpinner, closeSpinner } from "../../../js/modules/Dialogs";
import { CloseIcon, TrashIcon } from "../../../components/commonUI/Icons/SvgIcon";
import ConfirmDialog from "../../Modal/ConfirmDialog";
// import {
//   createCampaign,
//   updateCampaign,
//   unlinkCouponFromCampaign,
//   deleteCampaign,
// } from "../../../js/modules/Campaign";

const CreateCampaign = ({
  view,
  campaign,
  onClose,
  userDetails,
  theCallBackFunc,
}) => {
  const isEdit = view === "edit";
  const [campaignName, setCampaignName] = useState(campaign?.name || "");
  const [isLoading, setIsLoading] = useState(false);
  const [description, setDescription] = useState(campaign?.description || "");
  const [linkedDiscounts, setLinkedDiscounts] = useState([]);
  const [errors, setErrors] = useState({});
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // useEffect(() => {
  //   if (isEdit && campaign) {
  //     setCampaignName(campaign?.name || "");
  //     setDescription(campaign?.description || "");
  //     setLinkedDiscounts(campaign?.coupons || []);
  //   }
  // }, [campaign, isEdit]);

  const validateForm = () => {
    const newErrors = {};

    if (!campaignName.trim()) {
      newErrors.campaignName = "Campaign name is required";
    }

    if (!description.trim()) {
      newErrors.description = "Audience is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRemoveDiscount = (discountCode, discountId) => {
    showSpinner();
    const payload = {
      campaignId: campaign._id,
      couponId: discountId,
    };

    unlinkCouponFromCampaign(
      payload,
      (resStatus, responseString, resJson) => {
        closeSpinner();
        if (resStatus === 200 || resStatus === "200") {
          setLinkedDiscounts(
            linkedDiscounts?.filter((d) => d.code !== discountCode),
          );
          modal(
            resJson?.message || "Discount removed successfully!",
            null,
            () => {
              theCallBackFunc();
            },
          );
        } else {
          modal(
            resJson?.message || responseString || "Failed to remove discount",
          );
        }
      },
      userDetails.jwttoken,
    );
  };

  const handleDelete = () => {
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = () => {
    setShowDeleteConfirm(false);
    setIsLoading(true);
    showSpinner();

    const payload = { id: campaign._id };
    deleteCampaign(
      payload,
      (resStatus, responseString, resJson) => {
        closeSpinner();
        setIsLoading(false);
        if (resStatus === 200 || resStatus === "200") {
          modal(
            resJson?.message ||
              responseString ||
              "Campaign deleted successfully!",
          );
          onClose();
          if (theCallBackFunc) theCallBackFunc();
        } else {
          modal(
            resJson?.message ||
              responseString ||
              "Failed to delete campaign.",
          );
        }
      },
      userDetails?.jwttoken,
    );
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const payload = {
      name: campaignName.trim(),
      description: description.trim(),
    };

    if (isEdit && campaign?._id) {
      payload.id = campaign._id;
    }

    showSpinner();

    const callback = (resStatus, responseString, resJson) => {
      closeSpinner();

      if (resStatus === 200 || resStatus === "200") {
        modal(resJson?.message || "Campaign saved successfully!", null, () => {
          setErrors({});
          onClose();
          theCallBackFunc();
        });
      } else {
        modal(resJson?.message || responseString || "Failed to save campaign");
      }
    };

    if (isEdit) {
      updateCampaign(payload, callback, userDetails.jwttoken);
    } else {
      createCampaign(payload, callback, userDetails.jwttoken);
    }
  };

  return (
    <>
      <div className="discount-modal-overlay"></div>
      <div className="right-modal discount-modal">
        <div className="modal-header">
          <div className="modal-title">
            <h2>{isEdit ? "Edit Campaign" : "Create Campaign"}</h2>
            <button className="modal-close-btn" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label>Campaign name</label>
            <input
              type="text"
              placeholder="e.g., AFS Students"
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
            />
            {errors.campaignName && (
              <div className="field-error">{errors.campaignName}</div>
            )}
          </div>
          <div className="form-group">
            <label>Audience</label>
            <textarea
              placeholder="Who this campaign is for"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={4}
              className="campaign-audience-textarea"
            />
            {errors.description && (
              <div className="field-error">{errors.description}</div>
            )}
          </div>

          {isEdit && linkedDiscounts.length > 0 && (
            <div className="form-group">
              <label>Linked discount codes</label>
              <div className="linked-discounts-list">
                {linkedDiscounts?.map((discount) => (
                  <div key={discount?._id} className="discount-item">
                    <div className="discount-info">
                      <div className="discount-code">
                        {discount?.code}
                        {/* {discount?.computedStatus && (
                        <span className={`badge badge-${discount.computedStatus === "active" ? "success" : "secondary"}`}>
                          {discount?.computedStatus.charAt(0).toUpperCase() + discount?.computedStatus.slice(1)}
                        </span>
                      )} */}
                      </div>
                      <div className="discount-details">
                        { (
                          <span>
                            {discount?.value}
                            {discount?.valueType === "percent" ? "%" : "£"}{" "}
                            discount
                          </span>
                        )}

                        {(
                          <span>Min £{discount?.minOrderValue || 0}</span>
                        )}
                        { (
                          <span>
                            {discount?.appliesTo.charAt(0).toUpperCase() +
                              discount?.appliesTo.slice(1)}
                          </span>
                        )}
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={() =>
                        handleRemoveDiscount(
                          discount.code,
                          discount._id || discount.id,
                        )
                      }
                    >
                      <i className="bi bi-trash"></i>
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <div className="d-flex align-items-center g-12">
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isEdit ? "Update Campaign" : "Create Campaign"}
            </button>
            <button
              className="btn btn-outline-primary"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
          </div>
          {isEdit && campaign?.status?.toLowerCase() !== "revoked" && (
            <button
              className="btn btn-danger icon-with-btn"
              onClick={handleDelete}
              disabled={isLoading}
            >
              <TrashIcon />
              {isLoading ? "Deleting..." : "Delete"}
            </button>
          )}
        </div>

        <ConfirmDialog
          open={showDeleteConfirm}
          title="Delete Campaign"
          message="Are you sure you want to delete this campaign?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
          confirmText="Delete"
          cancelText="Cancel"
          variant="danger"
        />
      </div>
    </>
  );
};

export default CreateCampaign;
